import React from 'react';
import ErrorMessage from './ErrorMessage'
import {storage} from '../../utils'

import '../../styles/messages/VoiceMessage.css'
import voice_play_svg from '../../images/classroom/icon-play.png'
import voice_pause_svg from '../../images/classroom/icon-pause.png'
import voice_load_svg from '../../images/classroom/icon-load.png'


export default class VoiceMessage extends React.PureComponent {
    static isVoiceBoxClicked = false
    constructor() {
        super()
        /* stopped, loading, playing */
        this.state = {
            audioState: 'stopped',
            unread: true,
            currentTime: 0,
            dragBtnTargetLeft: 0,
            dragProgressElemWidth: 0,
            dragCurrentTime: 0,
            isDrag: false,
            isLineDrag: false,
        }
        this.touch = {}

        this.onVoiceBoxClick = this.onVoiceBoxClick.bind(this)
        this.onTouchStart = this.onTouchStart.bind(this)
        this.onTouchMove = this.onTouchMove.bind(this)
        this.onTouchEnd = this.onTouchEnd.bind(this)
        this.onMouseDown = this.onMouseDown.bind(this)
        this.onMouseMove = this.onMouseMove.bind(this)
        this.onMouseUp = this.onMouseUp.bind(this)
        this.onMove = this.onMove.bind(this)
        this.onDragClick = this.onDragClick.bind(this)
    }

    componentDidMount() {
        window.addEventListener('mouseup', this.onMouseUp)
        window.addEventListener('mousemove', this.onMouseMove)
    }

    componentWillUnmount() {
        window.removeEventListener('mouseup', this.onMouseUp)
        window.removeEventListener('mousemove', this.onMouseMove)
        this.quickIt && clearTimeout(this.quickIt)
    }

    /** 用于控制极简模式引导的展示 */
    toggleShowQuickGuide() {
        const beginListen = !VoiceMessage.isVoiceBoxClicked
        const date = new Date().getDate()
        const month = new Date().getMonth() + 1
        const hasClickQuick = storage.getItem(`wkShowQuickListen`)
        const quickShowNums = storage.getItem(`wkShowQuickListen_nums`)
        const dateQuickShow = storage.getItem(`wkShowQuickListen_${month}${date}`)
        // 如果已经点击去过极简模式 || 显示次数大于3 || 当天显示过，不再显示
        const hideQuick = hasClickQuick || quickShowNums > 2 || dateQuickShow

        if (beginListen && !hideQuick) {
            this.quickIt = setTimeout(() => {
                this.props.dispatch({type: 'CLASSROOM_SHOW_QUICK_GUIDE'})
            }, 10000)
        }
        VoiceMessage.isVoiceBoxClicked = true
    }

    onVoiceBoxClick(e) {
        // 展示极简模式的引导
        this.toggleShowQuickGuide()
        this.setState({isLineDrag: false})
        let operatePPT = this.props.message.ppt;
        if (this.state.audioState === 'stopped') {
            if (operatePPT) {
                // 如果绑定了ppt，则切换对应的ppt
                this.props.dispatch({
                    type: "CLASSROOM_SET_SELECTED_PPT",
                    payload: operatePPT
                });
            }
            this.context.messageList.onAudioStart(this);
            this.start();
        } else if (this.state.audioState === 'loading' || this.state.audioState === 'playing') {
            this.context.messageList.onAudioStop(this);
            this.stop();
        }
    }

    onDragClick(e) {
        e.stopPropagation()
    }

    componentWillMount() {
        const {message} = this.props
        if (this.context.messageList.isMessageRead(message.id)) {
            this.setState({unread: false});
        }
        this.context.messageList.audioItems[message.id] = this;
    }

    start() {
        this.setState({audioState: 'loading', currentTime: 0, unread: false});
    }

    stop() {
        this.setState({audioState: 'stopped'});
    }

    isInViewport() {
        const {message} = this.props
        const el = document.getElementById('message_' + message.id)
        if (el === null)
            return false
        const rect = el.getBoundingClientRect()
        const page = document.getElementById('page').getBoundingClientRect()
        // 需要加上50像素的底部栏
        const isVisible = rect.bottom > page.top && rect.bottom < screen.height - 50
        return isVisible
    }

    onMouseDown(e) {
        e.stopPropagation();
        this.touch = {
            x: e.clientX,
            y: e.clientY,
            touching: true
        }
        let dragProgressElemWidth = e.currentTarget.parentElement.parentElement.clientWidth
        let dragBtnTargetLeft = e.currentTarget.offsetLeft
        this.setState({dragProgressElemWidth, dragBtnTargetLeft, isDrag: true, isLineDrag: true})
    }

    onMouseMove(e) {
        // e.preventDefault();
        if (!this.touch.touching) {
            return;
        }
        this.onMove(e.clientX)
    }

    onMouseUp(e) {
        if (this.touch.touching) {
            this.touch = {};
            const {dragCurrentTime} = this.state;
            this.context.messageList.onAudioSeek(this, dragCurrentTime);
            this.setState({dragCurrentTime, isDrag: false});
            e.preventDefault();
        }
    }

    onTouchStart(e) {
        e.stopPropagation();
        this.touch = {
            x: e.touches[0].screenX,
            y: e.touches[0].screenY,
            touching: true
        }
        let dragProgressElemWidth = e.currentTarget.parentElement.parentElement.clientWidth
        let dragBtnTargetLeft = e.currentTarget.offsetLeft
        this.setState({dragProgressElemWidth, dragBtnTargetLeft, isDrag: true, isLineDrag: true})
    }

    onTouchMove(e) {
        e.preventDefault();
        if (!this.touch.touching) {
            return;
        }
        this.onMove(e.changedTouches[0].screenX)
    }

    onTouchEnd(e) {
        if (this.touch.touching) {
            this.touch = {};
            const {dragCurrentTime} = this.state;
            this.context.messageList.onAudioSeek(this, dragCurrentTime);
            this.setState({dragCurrentTime, isDrag: false});
            e.preventDefault();
        }
    }

    onMove(x) {
        const {message} = this.props
        const duration = message.meta.length
        const {dragProgressElemWidth, dragBtnTargetLeft} = this.state

        let dx = x - this.touch.x;
        let offsetLeft = dragBtnTargetLeft + dx + 3;
        if (offsetLeft > dragProgressElemWidth) {
            offsetLeft = dragProgressElemWidth;
        } else if (offsetLeft < 0) {
            offsetLeft = 0;
        }

        let dragBtnLeftRate = offsetLeft * 100 / dragProgressElemWidth

        // 反推currentTime
        let currentTime = dragBtnLeftRate * duration / 100;
        this.setState({dragCurrentTime: currentTime})
    }

    render() {
        try {
            const {message, currentAudioItem} = this.props
            let {isDrag, dragCurrentTime, currentTime} = this.state
            const duration = message.meta.length

            currentTime = isDrag ? dragCurrentTime : currentTime
            const boxWidth = Math.min(Math.floor(30 + duration / 2), 60);
            const fillWidth = currentTime >= duration ? '100' : Math.floor(currentTime * 100 / duration);
            return (<div className="voice-content">
                <div
                    className={"voice-box " + (this.state.audioState !== 'stopped' ? 'playing ' : '')}
                    onClick={this.onVoiceBoxClick}
                    style={{width: boxWidth + '%'}}
                    id={'voice_' + message.id}>

                    {this.state.audioState === 'stopped' &&
                    <img src={voice_play_svg} alt="voice" />
                    }
                    {this.state.audioState === 'loading' &&
                    <img className='icon-loading' src={voice_load_svg} alt="voice" />
                    }
                    {this.state.audioState === 'playing' &&
                    <img src={voice_pause_svg} alt="voice" />
                    }

                    <div className="box-voice-progress" style={{display: (currentAudioItem && currentAudioItem.props.message.id === message.id) ? 'block':'none'}}>
                        <div className="voice-play-progress" style={{width: fillWidth + '%'}}>
                            <div className="voice-drag-btn"
                                 onMouseDown={this.onMouseDown}
                                 onClick={this.onDragClick}
                                 onTouchStart={this.onTouchStart}
                                 onTouchMove={this.onTouchMove}
                                 onTouchEnd={this.onTouchEnd}>
                                {isDrag &&
                                <span className="voice-current">{parseInt(currentTime)}"</span>
                                }
                                <span className="drag-btn-inner"/>
                            </div>
                        </div>
                    </div>

                    {/*<div className="box-voice-arrow"/>*/}
                </div>
                <div className="voice-tags">
                    {this.state.unread &&
                    <div className="voice-unread">
                    </div>
                    }
                    <div className="voice-duration">
                        {duration}"
                    </div>
                </div>
            </div>)
        } catch(e) {
            return <ErrorMessage/>
        }
    }
}

VoiceMessage.contextTypes = {
    messageList: React.PropTypes.object
};




// WEBPACK FOOTER //
// ./src/components/messages/VoiceMessage.js